import React from "react";
import styles from "./index.module.scss";

export default function Skeleton({ isLoading, children }) {
    return (
        <>
            { isLoading
                ? <div className={styles.container}>
                    <div className={styles.head}>
                        <div className={styles.icon} />
                        <div className={styles.text} />
                    </div>
                    <div className={styles.content} />
                </div>
                : <>{ children }</>
            }
        </>
    )
}
